"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchMode = void 0;
exports.SearchModeFromJSON = SearchModeFromJSON;
exports.SearchModeFromJSONTyped = SearchModeFromJSONTyped;
exports.SearchModeToJSON = SearchModeToJSON;
exports.SearchModeToJSONTyped = SearchModeToJSONTyped;
/**
 *
 * @export
 * @enum {string}
 */
var SearchMode;
(function (SearchMode) {
    SearchMode["Global"] = "global";
    SearchMode["SiteOnly"] = "site-only";
})(SearchMode || (exports.SearchMode = SearchMode = {}));
function SearchModeFromJSON(json) {
    return SearchModeFromJSONTyped(json, false);
}
function SearchModeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function SearchModeToJSON(value) {
    return SearchModeToJSONTyped(value, false);
}
function SearchModeToJSONTyped(value, ignoreDiscriminator = false) {
    return value;
}
